import { useEffect, useSyncExternalStore } from "react";
import type { Message } from "src/layouts/AskDatatram/ChatInterface";
import {
  getCampaignStatus,
  setCampaignStatus,
  subscribeCampaignStatus,
} from "src/services/ChatbotAPI";

/** Marks the campaign as in progress each time the chat adds a campaign wizard step. */
export const useCampaignStatusSync = (query: Message[]) => {
  const wizardStepCount = query.filter(msg => msg.type === "campaignWizard").length;

  useEffect(() => {
    if (wizardStepCount > 0) {
      setCampaignStatus("in_progress");
    }
  }, [wizardStepCount]);
};

export const useCampaignStatus = () =>
  useSyncExternalStore(subscribeCampaignStatus, getCampaignStatus);
